import {dateCell} from 'items/ItemList';
import {NavLink} from 'react-router-dom';
import React from 'react'

export const navLinkCustomer = (cell, row) =>
    <NavLink to={`/customer/${row.id}`}>{cell}</NavLink>
export const openHoursCell = cell =>
    <span className={cell > 0 ? 'text-danger' : 'text-success'}>{cell}</span>

export const customerListColumns = [
    {
        text: 'Name',
        dataField: 'name',
        headerClasses: 'w-25',
        formatter: navLinkCustomer,
        sort: true
    },
    {
        text: 'PLZ',
        sort: true,
        dataField: 'location_address.zip'
    },
    {
        text: 'Ort',
        sort: true,
        dataField: 'location_address.city'
    },
    {
        text: 'Straße',
        sort: true,
        dataField: 'location_address.street'
    },
    {
        text: 'Haus-Nr.',
        sort: true,
        dataField: 'location_address.street_nr'
    },
    {
        text: 'BG',
        sort: true,
        dataField: 'pa'
    },
    {
        text: 'BG-Nr.',
        dataField: 'panr',
        sort: true
    },
    {
        text: 'Start',
        sort: true,
        dataField: 'coc',
        formatter: dateCell
    },
];

export const customerHoursColumns = [
    {
        text: 'Name',
        dataField: 'name',
        headerClasses: 'w-25',
        formatter: navLinkCustomer,
        sort: true
    },
    {
        text: 'Start',
        sort: true,
        dataField: 'coc',
        formatter: dateCell
    },
    {
        text: 'Regelbetreuung',
        sort: true,
        dataField: 'target_hours',
    },
    {
        text: 'Geleistete Stunden',
        sort: true,
        dataField: 'actual_hours',
    },
    {
        text: 'Offene Stunden',
        sort: true,
        dataField: 'remaining_hours',
        formatter: openHoursCell
    },
    {
        text: 'Nicht verrechnet',
        sort: true,
        dataField: 'not_in_invoice',
    },
    {
        text: 'Berechnungsinterval',
        sort: true,
        dataField: 'payment_interval_label',
    },
];
